import React from 'react'
import { useFormContext } from "react-hook-form";
import FormCss from "./fom.module.scss";

const Inputs = (props) => {

    const { register } = useFormContext();


    return (
        <div>
            <label htmlFor={props.id} className={`${FormCss.tabclix_input_label}`}>{props.label}</label>
            <input 
                className={`${FormCss.tabclix_input_field} ${FormCss.tabclix__w_input}`}
                type={props.type} 
                name={props.name.toLowerCase()}
                id={props.id} 
                placeholder={props.placeholder}
                {...register(`${props.name}`)}
                required={props.required}
                defaultValue={props.defaultValue}
                />
        </div>
    )
}

export default Inputs